module.exports = __webpack_public_path__ + "static/media/eksplosionen-interview.2ff11d43.mp3";